<template>
  <p></p>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { LoginService } from "@/services/rest/login/LoginService"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { ProjectService } from "@/services/rest/project/ProjectService"

export default defineComponent({
  name: "AcceptOrDeclineProjectInvitationPage",
  props: {
    projetId: {
      type: String,
      required: true,
    },
    acceptOrDecline: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loginService: LoginService.INSTANCE,
      projectService: ProjectService.INSTANCE,
      infoReportingService: InfoReportingService.INSTANCE,
    }
  },
  mounted() {
    // Logout if trying to accept or refuse an invitation not matched current user
    const loggedUser = this.loginService.getLoggedUser()
    if (loggedUser && loggedUser.id !== this.userId) {
      this.loginService.logout()
    }

    this.acceptOrDeclineAndGoToProjects()
  },
  methods: {
    async acceptOrDeclineAndGoToProjects(): Promise<void> {
      if (this.acceptOrDecline.indexOf("accept") !== -1) {
        await this.projectService.acceptProjetInclusion(this.projetId, this.userId)
      } else {
        await this.projectService.declineProjetInclusion(this.projetId, this.userId)
      }
      this.infoReportingService.success(this.$t("projet.acceptation").toString())
      await this.$router.push("/myProjects")
    },
  },
})
</script>
